/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect } from 'react';
import { Alerts, Spinner } from '@project/components';
import PageContentContainer from './../../components/PageContentContainer/PageContentContainer';
import { RootContext } from '../../hoc/RootContext/RootContext';
import { useIntl } from 'react-intl';
import Title from '../../components/Title/Title';
import { EditTeamMemberEmail } from './components/EditTeamMemberEmail';
import { useEditTeamMember } from './EditTeamMemberContext';
import { EditTeamMemberName } from './components/EditTeamMemberName';
import { EditTeamMemberMultiFormAuth } from './components/EditTeamMemberMultiFormAuth';
import { EditTeamMemberCompanyTitle } from './components/EditTeamMemberCompanyTitle';
import { EditTeamMemberStatus } from './components/EditTeamMemberStatus';
import { EditTeamMemberCompanyRole } from './components/EditTeamMemberCompanyRole';
import { useSaveUser } from './hooks/useSaveUser';
import { EditTeamMemberProperties } from './components/EditTeamMemberProperties';
import axios from '../../utils/axios';
import { riversideRoleOptions, roleOptions } from '../../constants';

export const EditTeamMemberForm = props => {
  const intl = useIntl();
  const t = id => intl.formatMessage({ id });
  const { saveUser } = useSaveUser();
  const {
    loading,
    errors,
    setErrors,
    user,
    company,
    setCompanyLevelAcl,
    properties,
    setIsLoaded,
    setLoading,
    setAcls,
    setGlobalAccess
  } = useEditTeamMember();

  const { currentUser } = useContext(RootContext);

  /*
   * get the user's company info, property list,
   * and all of the user's acls
   * */
  useEffect(() => {
    const fetch = async () => {
      try {
        setLoading(true);

        const safeUsername = encodeURIComponent(user.username);
        const safeCompany = encodeURIComponent(user.company);
        const url = `/acls?username=${safeUsername}&company=${safeCompany}&filter=false`;

        const result = await axios.get(url);
        if (result.status === 200) {
          // used below to set roleid on properties
          const acls = result.data.rows;
          setAcls(acls);

          const hasGlobalAccess = acls?.length === 1 && acls[0]?.company && !acls[0]?.property && !acls[0]?.section;
          setGlobalAccess(hasGlobalAccess);

          const companyAcl = acls.find(acl => !acl.property && !acl.section);
          setCompanyLevelAcl(companyAcl);
        }

        setIsLoaded(true);
      } catch (e) {
        if (e.response && e.response.data) {
          setErrors(`${t('error.serverData')} (${e.response.data.errors})`);
        } else {
          setErrors((e && e.message) || t('error.server'));
        }
      } finally {
        setLoading(false);
      }
    };

    if (user && properties.length < 1) {
      fetch();
    }
  }, [user.username, user.company]);

  if (!currentUser || !currentUser.companyAdmin) {
    return (
      <PageContentContainer>
        <h3 style={{ color: '#990000' }}>{t('error.notAuthorized')}</h3>
      </PageContentContainer>
    );
  }

  return (
    <>
      <PageContentContainer>
        <Title
          title={t('EditTeamMember.mainTitle')}
          backRoute={'/users'}
          button={{ click: saveUser, label: t('EditTeamMember.updateMember') }}
        />

        {errors.length > 0 ? (
          <div style={{ marginTop: '20px' }}>
            <Alerts messages={errors} close={() => setErrors([])} />
          </div>
        ) : null}

        <EditTeamMemberEmail />
        <EditTeamMemberName />
        <EditTeamMemberMultiFormAuth />

        {company.isVendorCompany ? (
          <>
            <EditTeamMemberStatus />
            <EditTeamMemberCompanyRole roleOptions={riversideRoleOptions} />
          </>
        ) : (
          <>
            <EditTeamMemberCompanyTitle />
            <EditTeamMemberStatus />
            <EditTeamMemberCompanyRole roleOptions={roleOptions} />
            <EditTeamMemberProperties />
          </>
        )}
      </PageContentContainer>
      {loading ? <Spinner /> : null}
    </>
  );
};
